module.exports = __webpack_public_path__ + "img/img2.3b877350.png";